import React, { useEffect } from 'react';
import Logger from '@/utils/logger';

declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}

const FACEBOOK_PIXEL_ID = '715938994406157';

const FacebookPixel: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  useEffect(() => {
    initializeFacebookPixel();
  }, []);

  const initializeFacebookPixel = () => {
    try {
      if (document.querySelector(`script[src*="connect.facebook.net"]`)) {
        return;
      }

      (function(f: any, b: any, e: any, v: any, n?: any, t?: any, s?: any) {
        if (f.fbq) return;
        n = f.fbq = function() {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = '2.0';
        n.queue = [];
        t = b.createElement(e);
        t.async = !0;
        t.src = v;
        s = b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t, s);
      })(
        window,
        document,
        'script',
        'https://connect.facebook.net/en_US/fbevents.js'
      );

      const checkFbq = () => {
        if (window.fbq && typeof window.fbq === 'function') {
          window.fbq('init', FACEBOOK_PIXEL_ID);
          window.fbq('track', 'PageView');
          Logger.info('Facebook Pixel initialized successfully.');
        } else {
          setTimeout(checkFbq, 100);
        }
      };

      checkFbq();

    } catch (error) {
      Logger.error('Failed to initialize Facebook Pixel:', error);
    }
  };

  return <>{children}</>;
};

export const trackFBEvent = (eventName: string, parameters?: any) => {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', eventName, parameters);
  }
};

export const trackFBPageView = () => {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'PageView');
  }
};

export default FacebookPixel;
